



























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { db, firestore } from "@/scripts/firebase";
import EditableTitle from "@/components/JinroRoom/EditableTitle.vue";
import PlayerListViewWithStatus from "@/components/shared/PlayerListViewWithStatus.vue";
import Billboard from "@/components/JinroRoom/Billboard.vue";
import ManageJinroPlayers from "@/components/JinroRoom/ManageJinroPlayers/ManageJinroPlayers.vue";
import StartingJinroGame from "@/components/JinroRoom/StartingJinroGame.vue";
import { collectionName } from "../services/collection-name";
import {
  JinroRoomDocument,
  JinroPlayerStatisticsDocument,
  JinroPlayerDocument,
} from "../services/datatypes";
import JinroRoomRanking from "@/components/JinroRoom/JinroRoomRanking.vue";
import ShareUrl from "@/components/JinroRoom/ShareUrl.vue";
import RoomGameHistorySummaries from "@/components/JinroRoom/RoomGameHistorySummaries.vue";
import FriendlyFowaringToJinroPlayer from "@/components/JinroRoom/FriendlyFowaringToJinroPlayer.vue";

@Component({
  components: {
    PlayerListViewWithStatus,
    Billboard,
    ManageJinroPlayers,
    EditableTitle,
    StartingJinroGame,
    JinroRoomRanking,
    ShareUrl,
    RoomGameHistorySummaries,
    FriendlyFowaringToJinroPlayer,
  },
})
export default class JinroRoom extends Vue {
  guestName = "";
  jinroRoom: JinroRoomDocument | null = null;
  detacher?: firebase.Unsubscribe;
  activeTab = 0;
  playerNumber = 0;
  roomGameHistoriesLength = 0;

  async created() {
    this.detacher = this.refJinroRoom.onSnapshot((snapshot) => {
      this.jinroRoom = snapshot.data() as JinroRoomDocument;
      this.jinroRoom.id = snapshot.id;
      this.$store.commit("setJinroRoom", this.jinroRoom);
    });
  }
  destroyed() {
    this.detacher && this.detacher();
  }

  get isNotDeleted(): boolean {
    if (this.jinroRoom) {
      return !this.jinroRoom.isDeleted;
    }

    return true;
  }

  get playerId(): string {
    if (
      !this.$store.state.firebaseUser ||
      !this.$store.state.jinroRoomPlayers
    ) {
      return "";
    }
    const uid = this.$store.state.firebaseUser.uid;
    const players = this.$store.state.jinroRoomPlayers as Array<
      JinroPlayerDocument
    >;

    const player = players.find((player) => {
      return player.uid === uid;
    });
    if (player) {
      return player.id;
    }

    return "";
  }

  get refJinroRoom(): firebase.firestore.DocumentReference {
    return db
      .collection(collectionName.jinrorooms)
      .doc(this.$route.params.jinroRoomId);
  }

  get isOwner() {
    if (!this.jinroRoom) {
      return false;
    }
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }
  get playerStatistics(): Array<JinroPlayerStatisticsDocument> {
    if (!this.jinroRoom || !this.jinroRoom.jinroRoomPlayersStatistics) {
      return [];
    }
    return this.jinroRoom.jinroRoomPlayersStatistics;
  }
}
